var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29145 2.7478H23.1674V1.42322C23.1674 0.636928 22.5131 2.35174e-06 21.7057 2.35174e-06H1.45889C0.654334 -0.00140667 0 0.636928 0 1.42322V21.2102C0 21.9965 0.654334 22.6334 1.45889 22.6334H2.83256V4.17384C2.83256 3.38614 3.48689 2.7478 4.29145 2.7478V2.7478Z",
    fill: "#44A6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1679 5.65485H24.7265C25.4285 5.65485 26.0005 6.21145 26.0005 6.89629V23.958C26.0005 24.7457 25.3462 25.3812 24.5387 25.3812H7.07971C6.37915 25.3812 5.80859 24.826 5.80859 24.1412V22.632V6.89629C5.80859 6.21145 6.37915 5.65485 7.07971 5.65485H23.1679Z",
    fill: "#0270B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9294 11.6007C14.9294 11.9881 14.6362 12.3045 14.2722 12.3045H9.20796C8.84541 12.3045 8.54785 11.9881 8.54785 11.6007V11.6007C8.54785 11.2102 8.84396 10.8954 9.20796 10.8954H14.2722C14.6362 10.8969 14.9294 11.2102 14.9294 11.6007V11.6007V11.6007Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.311 16.2579C21.311 16.6469 21.0149 16.9617 20.6509 16.9617H9.20796C8.84541 16.9617 8.54785 16.6469 8.54785 16.2579V16.2579C8.54785 15.869 8.84396 15.5526 9.20796 15.5526H20.6509C21.0149 15.5526 21.311 15.869 21.311 16.2579V16.2579V16.2579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.311 20.9163C21.311 21.3068 21.0149 21.6217 20.6509 21.6217H9.20796C8.84541 21.6217 8.54785 21.3068 8.54785 20.9163V20.9163C8.54785 20.5274 8.84396 20.2125 9.20796 20.2125H20.6509C21.0149 20.2125 21.311 20.5274 21.311 20.9163V20.9163V20.9163Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5856 8.9818L20.6986 12.7907C20.5889 12.8992 20.456 12.9865 20.3115 13.0429C20.1642 13.1035 20.0096 13.1331 19.8522 13.1331C19.6976 13.1331 19.5388 13.1035 19.3958 13.0429C19.2484 12.9865 19.117 12.8992 19.0058 12.7907L17.167 11.0842C16.9474 10.863 16.8203 10.5643 16.8203 10.2571C16.8203 9.94846 16.9474 9.65114 17.167 9.43131C17.2768 9.31999 17.4068 9.22981 17.5541 9.17203C17.7014 9.11144 17.856 9.08185 18.0134 9.08185C18.1709 9.08185 18.3269 9.11144 18.4728 9.17203C18.6201 9.22981 18.7486 9.31999 18.8599 9.43131L19.7626 10.3106L22.7989 7.34721C22.9115 7.23589 23.0444 7.14852 23.186 7.08652C23.3333 7.02593 23.4908 6.99634 23.6482 6.99634C23.8056 6.99634 23.9645 7.02593 24.1075 7.08652C24.2549 7.14712 24.3834 7.23448 24.4946 7.34721C24.616 7.44585 24.7113 7.56704 24.7821 7.70513C24.8529 7.84322 24.889 7.99259 24.9005 8.14478C24.9092 8.29837 24.8832 8.45197 24.8326 8.59429C24.7778 8.73802 24.694 8.87048 24.5856 8.9818V8.9818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.6f5ade09fce5f83092d5697b505424a9.svg";
export { ForwardRef as ReactComponent };